/**
 * Converts an image URI to base64 format (Web version)
 * @param imageUri - The URI of the image to convert
 * @returns Promise that resolves to base64 string
 */
export const getBase64Image = async (imageUri: string): Promise<string> => {
  try {
    // For web, we need to use fetch to get the image data
    const response = await fetch(imageUri);
    const blob = await response.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result as string;
        // Remove the data:image/...;base64, prefix if present
        const base64Data = base64String.split(',')[1] || base64String;
        resolve(base64Data);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('Error converting image to base64:', error);
    throw error;
  }
};

/**
 * Validates if the URI is a valid image
 * @param uri - The URI to validate
 * @returns boolean indicating if it's a valid image URI
 */
export const isValidImageUri = (uri: string): boolean => {
  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp'];
  const lowerUri = uri.toLowerCase();

  // Check for data URI
  if (lowerUri.startsWith('data:image/')) {
    return true;
  }

  // Check for file extension
  return imageExtensions.some((ext) => lowerUri.includes(ext));
};

/**
 * Creates a WebView bridge API for web platforms
 * This is a factory function that creates a bridge API instance
 */
export const createWebBridgeApi = () => {
  // This would be implemented in the web application
  // Returns a bridge API instance configured for web
  return {
    // Web-specific implementation
  };
};
